module.exports = __webpack_public_path__ + "img/teams-user-folder-delete.981ab284.svg";